import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import { MatPseudoCheckbox } from './pseudo-checkbox.mjs';
import { MatCommonModule } from './common-module.mjs';
let MatPseudoCheckboxModule = /*#__PURE__*/(() => {
  class MatPseudoCheckboxModule {
    static ɵfac = function MatPseudoCheckboxModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatPseudoCheckboxModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MatPseudoCheckboxModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [MatCommonModule]
    });
  }
  return MatPseudoCheckboxModule;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
export { MatPseudoCheckboxModule };
